const styles = {
  eventsRoot: {
    color: 'rgba(0, 0, 0, 0.54)',
    'margin-bottom': '2px',
    'line-height': 1
  }
};

export default styles;
